import { gql } from '@apollo/client';

export const SEND_FORGOT_PASSWORD = gql`
  mutation requestForgotPassword($email: String!) {
    requestForgotPassword(email: $email) {
      isSucceed
    }
  }
`;
